import styles from '../index.module.css'

import { RxCheck } from '@react-icons/all-files/rx/RxCheck'
import React from 'react'

import { HoverCard } from 'components/ds'

import type { ColoredTag } from './tag-dot'
import { TagDot } from './tag-dot'

type Props = {
  /** Every coloured tag on the track, actives first — the card lists them all. */
  tags: ColoredTag[]
  /** How many of those tags did not fit in the cell as dots. */
  hiddenCount: number
  activeIdSet: ReadonlySet<number>
  onTagClick: (event: React.MouseEvent, tagId: number) => void
}

/** `+N` badge that reveals the full, clickable tag list on hover. */
export const OverflowHoverCard = ({
  tags,
  hiddenCount,
  activeIdSet,
  onTagClick,
}: Props) => (
  <HoverCard.Root openDelay={200} closeDelay={100}>
    <HoverCard.Trigger>
      <button
        type="button"
        className={styles.hoverableBadge}
        aria-label={`Show all ${tags.length} indicators`}
      >
        +{hiddenCount}
      </button>
    </HoverCard.Trigger>
    <HoverCard.Content
      size="1"
      side="top"
      align="start"
      className={styles.tagList}
      data-testid="indicators-hover-card"
    >
      {tags.map(tag => {
        const isActive = activeIdSet.has(tag.id)
        return (
          <button
            key={tag.id}
            type="button"
            className={styles.tagRow}
            data-active={isActive || undefined}
            aria-pressed={isActive}
            onClick={event => onTagClick(event, tag.id)}
          >
            <TagDot color={tag.color} />
            <span className={styles.tagRowLabel}>{tag.name}</span>
            {isActive && <RxCheck size={16} className={styles.tagRowCheck} />}
          </button>
        )
      })}
    </HoverCard.Content>
  </HoverCard.Root>
)
